// extracted by mini-css-extract-plugin
export default {"cards":"styles_cards__TNohv","card":"styles_card__E+NVQ"};